// extracted by mini-css-extract-plugin
export default {"container":"aside_filters-module__container--2P1QO"};